<template>
  <div class="AgentsAndNumbersViewHint">
    <div class="content">
      <div class="content__header">
        W tym oknie znajduje się lista Twoich numerów oraz konsultantów,
        do których sa przypisani
      </div>
      <div class="content__row">
        <div class="content__point">
          <div class="point__number">
            1
          </div>
        </div>
        <label>
          Wybierz numer
        </label>
      </div>
      <div class="content__row">
        <div class="content__point">
          <div class="point__number">
            2
          </div>
        </div>
        <label>
          Zweryfikuj numer
        </label>
      </div>
      <div class="content__row">
        <div class="content__point">
          <div class="point__number">
            3
          </div>
        </div>
        <label>
          Przypisz konsultanta
        </label>
      </div>
      <div class="content__row">
        <div class="content__point">
          <div class="point__number">
            4
          </div>
        </div>
        <label>
          Zarządzaj kontem konsultanta
        </label>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'AgentsAndNumbersViewHint',
};
</script>
